// 単体テスト実行時はenvがundefinedとなるため「||」で値を設定する

/**
 * AWS
 */
export const aws = {
  /** リージョン */
  aws_project_region: import.meta.env.VITE_AWS_PROJECT_REGION || '',
  /** Cognitoリージョン */
  aws_cognito_region: import.meta.env.VITE_AWS_COGNITO_REGION || '',
  /** ユーザープールID */
  aws_user_pools_id: import.meta.env.VITE_AWS_USER_POOLS_ID || '',
  /** WebクライアントID */
  aws_user_pools_web_client_id: import.meta.env.VITE_AWS_USER_POOLS_WEB_CLIENT_ID || '',
  /** GraphQLエンドポイント */
  aws_appsync_graphqlEndpoint: import.meta.env.VITE_AWS_APPSYNC_GRAPHQL_ENDPOINT || '',
  /** Appsync リージョン */
  aws_appsync_region: import.meta.env.VITE_AWS_APPSYNC_REGION || '',
  /** Appsync 権限タイプ */
  aws_appsync_authenticationType: import.meta.env.VITE_AWS_APPSYNC_AUTHENTICATION_TYPE || '',
};

/** apiWagakoAppUrl */
export const apiWagakoAppUrl = import.meta.env.VITE_API_WAGAKO_APP_URL || '';

/** apiWagakoNurseryUrl */
export const apiWagakoNurseryUrl = import.meta.env.VITE_API_WAGAKO_NURSERY_URL || '';

/**
 * ビルドしたものかどうか
 */
export const isDebug = import.meta.env.DEV;

/** InfraをFakeするか */
export const isFakeInfra = import.meta.env.VITE_API_IS_FAKE_INFRA === 'TRUE';

/** バージョン */
export const version = import.meta.env.VITE_VERSION || '0.0.0';

/** 画像フォルダパス */
export const imageFolderPath = 'images/';

/** リトライ数 */
export const retries = parseInt(import.meta.env.VITE_RETRIES || '1', 10);

/** ヒストリのログ数 */
export const logNumberOfHistory = parseInt(import.meta.env.VITE_LOG_NUMBER_OF_HISTORY || '20', 10);

/** ログの最大長さ */
export const logMaxMessageStringLength = parseInt(import.meta.env.VITE_LOG_MAX_MESSAGE_STRING_LENGTH || '10', 10);

/** FireBaseの設定 */
export const firebaseConfig = {
  /** APIキー */
  apiKey: import.meta.env.VITE_FIREBASE_CONFIG_API_KEY || '',
  /** Authドメイン */
  authDomain: import.meta.env.VITE_FIREBASE_CONFIG_AUTH_DOMAIN || '',
  /** プロジェクトID */
  projectId: import.meta.env.VITE_FIREBASE_CONFIG_PROJECT_ID || '',
  /** ストレージバケット */
  storageBucket: import.meta.env.VITE_FIREBASE_CONFIG_STORAGE_BUCKET || '',
  /** メッセージング送信者ID */
  messagingSenderId: import.meta.env.VITE_FIREBASE_CONFIG_MESSAGING_SENDER_ID || '',
  /** APP ID */
  appId: import.meta.env.VITE_FIREBASE_CONFIG_API_ID || '',
  /** 測定者ID */
  measurementId: import.meta.env.VITE_FIREBASE_CONFIG_MEASUREMENT_ID || '',
};

/** vapidKey */
export const vapidKey = import.meta.env.VITE_FIREBASE_CONFIG_VAPID_KEY || '';
export default aws;
